exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".stripe-card-container[data-v-db3a9528]{border:1px solid grey;border-radius:2px;margin:auto;width:100%;padding:2px}", ""]);

// exports
